import { CommonCalendarActions, CommonCalendarEffects, CommonCalendarState } from './types';
import { EffectReducerExec } from 'use-effect-reducer';
const VALID_DATE = 2;
export function commmonReducer<S extends CommonCalendarState>(
  draft: CommonCalendarState,
  action: CommonCalendarActions,
  exec: EffectReducerExec<S, CommonCalendarActions, CommonCalendarEffects>
) {
  // console.log('action', action);
  switch (action.type) {
    case 'SET_TYPE_ERROR':
      draft.typeError = action.payload;
      break;
    case 'SET_MONTHS':
      draft.months = action.payload;
      break;
    case 'SET_SELECTED_INPUT':
      draft.selectedComponent = action.payload;
      break;
    case 'SET_VALID':
      draft.valid = action.payload;
      break;
    case 'SET_PREVIOUS_DATE':
      draft.previousDate = action.payload;
      break;
    case 'SET_PRESELECTED_DATE':
      draft.preSelected = action?.payload;
      draft.valid = true;
      draft.typeError = VALID_DATE;
      break;
    case 'SET_INPUT_VALUE':
      if (action.component === 'start') {
        draft.inputValue.start = action.payload;
      } else if (action.component === 'end') {
        draft.inputValue.end = action.payload;
      } else {
        draft.inputValue = { start: action.payload, end: undefined }; //Set by default start
      }
      break;
    case 'SET_FLEXIBLE_DATES_CHECKED':
      draft.isCheckedFlexibleDates = action.payload;
      break;
    case 'SET_USER_INTERACTION_ACTION':
      draft.userInteraction = action.payload;
      break;
    case 'SET_TAB_ACTION_INPUT':
      draft.tabActionOnInput = action.payload;
      break;
    case 'SET_FLEXIBLE_DATES_VALUE':
      draft.flexibleValue = action.payload;
      break;
    case 'SET_FOCUS_SELECTED_DAY':
      draft.focusSelectedDay = action.payload;
      break;
    case 'SET_DISPLAY_DATE_ACTION':
      draft.displayDate = action.payload;
      exec(action);
      break;
    case 'CHANGE_CURRENT_MONTH':
      draft.currentMonth = action.payload;
      break;
    case 'SET_DATE_ACTION':
      if (action.payload) {
        draft.preSelected = action.payload;
        draft.displayDate = action.payload;
        if (action.component === 'start') {
          draft.currentDate = { ...draft.currentDate, start: action.payload };
        } else if (action.component === 'end') {
          draft.currentDate = { ...draft.currentDate, end: action.payload };
        }
      }
      draft.focusSelectedDay = false;
      draft.valid = true;
      draft.typeError = VALID_DATE;
      exec(action);
      break;
    case 'CHANGE_ACTION':
    case 'OPEN_POPOVER_ACTION':
    case 'CLOSE_POPOVER_ACTION':
      exec(action);
      break;
    case 'SET_POPOVER':
      draft.popoverOpen = action.payload.popoverOpen;
      draft.focusSelectedDay = action.payload.focusSelectedDay;
      break;
    case 'SELECT_DAY_ACTION':
      if (draft.selectedComponent === 'start') {
        if (draft.currentDate) {
          draft.currentDate = { ...draft.currentDate, start: action.payload.start };
        } else {
          draft.currentDate = action.payload;
        }
      } else {
        if (draft.currentDate) {
          draft.currentDate = { ...draft.currentDate, end: action.payload.end };
        } else {
          draft.currentDate = action.payload;
        }
      }
      draft.valid = true;
      draft.typeError = VALID_DATE;
      exec(action);
      break;
    case 'SET_CURRENT_DATE':
      if (draft.selectedComponent === 'start') {
        if (draft.currentDate) {
          draft.currentDate = { ...draft.currentDate, start: action.payload.start };
        } else {
          draft.currentDate = action.payload;
        }
      } else {
        if (draft.currentDate) {
          draft.currentDate = { ...draft.currentDate, end: action.payload.end };
        } else {
          draft.currentDate = action.payload;
        }
      }
      draft.valid = true;
      draft.typeError = VALID_DATE;
      break;
    case 'CLEAR_ACTION':
      draft.isCheckedFlexibleDates = false;
      draft.inputValue = { start: '', end: '' };
      draft.preSelected = undefined;
      draft.currentDate = null;
      draft.focusSelectedDay = false;
      draft.valid = true;
      draft.typeError = VALID_DATE;
      exec(action);
      break;
    case 'CLEAR_ACTION_DEPARTURE':
      draft.isCheckedFlexibleDates = false;
      draft.inputValue = { start: '', end: draft.inputValue.end };
      draft.preSelected = undefined;
      draft.selectedRange = { start: undefined, end: draft.selectedRange?.end };
      draft.currentDate = { start: undefined, end: draft.currentDate?.end };
      draft.focusSelectedDay = false;
      draft.valid = true;
      draft.typeError = VALID_DATE;
      exec(action);
      break;
    case 'CLEAR_ACTION_RETURN':
      draft.isCheckedFlexibleDates = false;
      draft.inputValue = { start: draft.inputValue.start, end: '' };
      draft.preSelected = undefined;
      draft.selectedRange = { end: undefined, start: draft.selectedRange?.start };
      draft.currentDate = { start: draft.currentDate?.start, end: undefined };
      draft.focusSelectedDay = false;
      draft.valid = true;
      draft.typeError = VALID_DATE;
      exec(action);
      break;
    case 'RESET_ACTION':
      draft.isCheckedFlexibleDates = false;
      draft.inputValue = { start: '', end: '' };
      draft.preSelected = undefined;
      draft.selectedRange = {};
      draft.currentDate = null;
      draft.focusSelectedDay = false;
      draft.valid = true;
      draft.typeError = VALID_DATE;
      exec(action);
      break;
    case 'RESET_ACTION_AND_CLEAR_STATE':
      draft.isCheckedFlexibleDates = false;
      draft.selectedRange = {};
      draft.inputValue = { start: '', end: '' };
      draft.preSelected = undefined;
      draft.currentDate = null;
      draft.focusSelectedDay = false;
      draft.valid = true;
      draft.validEnd = true;
      draft.typeError = VALID_DATE;
      draft.typeErrorEnd = VALID_DATE;
      exec(action);
      break;
    case 'UNDO_ACTION':
      draft.inputValue = { start: '', end: '' };
      draft.preSelected = undefined;
      draft.focusSelectedDay = false;
      draft.valid = true;
      draft.typeError = VALID_DATE;
      exec(action);
      break;
    case 'PARSE_INPUT_ACTION':
      exec(action);
      break;
    case 'CANCEL_ACTION':
      draft.focusSelectedDay = false;
      exec(action);
      break;
    case 'SET_CURRENT_MONTH_DATE_A11Y': {
      draft.currentMonthDateA11y = action.payload;
      break;
    }
    default:
  }
}
